/**
 * Shield bonus: shield.png — Fall-stage shield vs boulders (until stage end or boulder break).
 */
import { gameImageUrl } from "../../assets/game-image-urls.js";
import { getCachedImage } from "../../assets/image-cache.js";
import { RunGameObject } from "./GameObject.js";

function getShieldImage() {
  return getCachedImage(gameImageUrl("shield"));
}

export class RunBonus extends RunGameObject {
  constructor(bottomCenterPosition, slot, progress, width) {
    super(bottomCenterPosition, slot, progress, width);
  }
  getType() { return "bonus"; }
  getAspectRatio() {
    var img = getShieldImage();
    if (img && img.naturalWidth > 0) {
      return img.naturalWidth / img.naturalHeight;
    }
    return 1;
  }
  getDrawImage() {
    return getShieldImage();
  }

  draw(ctx, pixelX, pixelY, pixelW, pixelH) {
    if (this.collected) return;
    var shieldImg = getShieldImage();
    var aspect = this.getAspectRatio();
    var drawW = pixelW;
    var drawH = pixelW / aspect;
    if (drawH > pixelH) {
      drawH = pixelH;
      drawW = pixelH * aspect;
    }
    var drawX = pixelX + (pixelW - drawW) / 2;
    var drawY = pixelY + (pixelH - drawH) / 2;
    ctx.save();
    if (shieldImg) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(shieldImg, 0, 0, shieldImg.naturalWidth, shieldImg.naturalHeight, drawX, drawY, drawW, drawH);
    } else {
      ctx.fillStyle = "#aa44ff";
      ctx.fillRect(drawX, drawY, drawW, drawH);
      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 18px monospace";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("S", drawX + drawW / 2, drawY + drawH / 2);
    }
    ctx.restore();
  }
}